/**
 * Утилита для определения API URL
 * Автор: Cursor Generator
 * Описание: Автоматически определяет правильный API URL в зависимости от окружения
 */

import { Capacitor } from '@capacitor/core';

// Функция для определения API URL
const getApiUrl = () => {
  // Если есть переменная окружения - используем её
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  // Для нативного приложения (Android/iOS) - всегда используем полный URL
  try {
    if (Capacitor.isNativePlatform()) {
      return 'https://aimarkethub.ru/api';
    }
  } catch {
    // Capacitor не доступен
  }
  
  // Для веб-версии
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Локальная разработка
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:4000/api';
    }
    
    // Production - относительный путь
    return '/api';
  }
  
  // Fallback
  return 'https://aimarkethub.ru/api';
};

export const API_URL = getApiUrl();

// Экспортируем также базовый URL для мобильного
export const BASE_URL = 'https://aimarkethub.ru';
